import authService from '@/authentication/authentication.service';
import { ConnectClaim } from '@/authentication/claims';
import { ApplicationInsights, ICustomProperties, IEventTelemetry } from '@microsoft/applicationinsights-web';
import { config } from '@/config/config';

class AppInsightsService {
  private insights: ApplicationInsights;

  public init() {
    this.insights = new ApplicationInsights({
      config: {
        connectionString: `InstrumentationKey=${config().telemetryKey};IngestionEndpoint=${config().telemetryHost}`,
        enableAutoRouteTracking: true,
      },
    });
    this.insights.loadAppInsights();
  }

  public trackEvent(event: IEventTelemetry, customProperties?: ICustomProperties) {
    this.insights.trackEvent(event, customProperties);
  }

  public trackPageView() {
    this.insights.trackPageView();
  }

  public setAuthenticatedUserContext() {
    const userId = authService.getClaim(ConnectClaim.UserId);
    this.insights.setAuthenticatedUserContext(userId, undefined, true);
    this.insights.context.user.id = userId;
  }
}

export default new AppInsightsService();
